import { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import { useNavigate } from 'react-router-dom';

import { Box } from '@mui/material';

import PoolExplain from '@/component/pools/PoolExpplain/PoolExplain';
import ClaimList from '@/component/pools/ClaimList';
import CommonTop from '@/component/pools/CommonTop';
import UnStakeList from '@/component/pools/UnStakeList';

import { useWeb3 } from '@/hooks/use-web3';
import { PoolState, RES_SUCCESS } from '@/lib/common/name-space';
import { isCheckWithdraw, poolDetail, rewardList, stateWithdraw } from '@/api/staking/read';
import { PoolListType } from '@/types';
import RewardList from '@/component/pools/RewardList';
import WithdrawAll from '@/component/pools/WithdrawAll';
import { RewardListType } from '@/types/staking/read';
import { useWeb3AuthConnect } from '@web3auth/modal/react';

export default function StakeDetail() {
  // const {
  //   state: { contractAddr, poolId },
  // } = useLocation();

  const location = useLocation();
  const state = location.state || {}; // state가 null/undefined인 경우 기본값으로 빈 객체 사용
  const { contractAddr, poolId } = state;

  // const [state, setState] = useState('');
  // const [title, setTitle] = useState('');

  const navigate = useNavigate();
  const [detail, setDetail] = useState<PoolListType | null>(null);

  const { isConnected } = useWeb3AuthConnect();

  useEffect(() => {
    if (isConnected) {
      return;
    }
    console.log(isConnected);
    navigate('/pools');
  }, [isConnected]);

  useEffect(() => {
    if (!contractAddr || !poolId) {
      navigate('/pools');
      return;
    }

    return () => {};
  }, [contractAddr, poolId, navigate]);

  // useEffect(() => {
  //   // if (!contractAddr) {
  //   //   // 이전화면으로 이동
  //   //   navigate('/portfolio');
  //   //   return;
  //   // }
  //   if (web3authCall?.connected()) {
  //     (async () => {
  //       const arrPromise = [];
  //       arrPromise.push(() => web3authCall.callStaking(STATE, contractAddr));
  //       arrPromise.push(() => web3authCall.callStaking(GETPOOLDETAILS, contractAddr));

  //       try {
  //         const re = await promiseAllSettled(arrPromise);
  //         // setState(re[0]);
  //         // setTitle(re[1].name);
  //       } catch (e) {
  //         console.error(e);
  //       }
  //       // const re = await web3authCall.callStaking(STATE, contractAddr);
  //       // setState(re);
  //       // const res = await web3authCall.callStaking(GETPOOLDETAILS, contractAddr);
  //     })();
  //   }

  //   return () => {};
  // }, [contractAddr, web3authCall]);

  useEffect(() => {
    if (!poolId || !contractAddr) {
      navigate('/portfolio');
      return;
    }
    (async () => {
      try {
        const re = await poolDetail(poolId);
        // if (
        //   [
        //     PoolState.POOLSTATE_FUNDRAISING,
        //     PoolState.POOLSTATE_FUNDRAISING_LOCKED,
        //     PoolState.POOLSTATE_FUNDRAISING_STOPPED,
        //     PoolState.POOLSTATE_FUNDRAISING_FAILED,
        //   ].includes(re.data.state)
        // ) {
        //   setDetail(re.data);
        // }
        setDetail(re.data);
      } catch (e) {
        console.error(e);
      }
    })();
    return () => {};
  }, [poolId, contractAddr]);

  const TriggerWithdrawAll = () => {
    const [isClaimReward, setIsClaimReward] = useState(false); // 받을 수량이 있음 false, 모든 리워드 받으면 true
    const { address: addr } = useWeb3();
    useEffect(() => {
      if (addr && detail) {
        (async () => {
          // rewardList() 추가
          const rewardListType: RewardListType = {
            poolId: detail.poolId,
            address: addr,
          };
          // 받을 리워드가 있는지 체크
          const re = await rewardList(rewardListType);
          if (re.status !== RES_SUCCESS) {
            return;
          }
          const length = re.data.length;
          if (length !== 0) {
            return;
          }
          // 원금 회수를 했는지 체크
          const alreadyWithdraw = await stateWithdraw(rewardListType);
          if (alreadyWithdraw.status !== 200) {
            return;
          }
          if (Boolean(alreadyWithdraw.data) === true) {
            return;
          }

          // 리워드 세팅 마지막 날인지 체크
          const checkWithdraw = await isCheckWithdraw(detail.poolId);
          console.log(checkWithdraw);
          if (checkWithdraw.status !== RES_SUCCESS) {
            return;
          }
          setIsClaimReward(Boolean(checkWithdraw.data));
        })();
      }
      return () => {};
    }, [addr]);

    if (!detail) {
      return <></>;
    }

    return (
      <>
        {isClaimReward ? (
          <>
            <WithdrawAll detail={detail} />
            <Box mb={2} />
          </>
        ) : (
          ''
        )}
      </>
    );
  };
  const TriggerUnStakeList = () => {
    if (!detail) {
      return <></>;
    }
    return <UnStakeList contractAddr={contractAddr} detail={detail} />;
    /* UnStaked Section */
    // if (detail.state === PoolState.POOLSTATE_FUNDRAISING) {
    //   return <UnStakeList contractAddr={contractAddr} detail={detail} />;
    // }
    // return <UnStakeList contractAddr={contractAddr} detail={detail} />;
  };
  const TriggerRewardList = () => {
    if (!detail) {
      return <></>;
    }
    return <RewardList poolId={detail.poolId} contractAddr={contractAddr} />;
  };
  return (
    <>
      <Box
        sx={{
          display: 'flex',
          overflow: 'auto',
          flex: 1,
          flexDirection: 'column',
          gap: { xs: '16px', md: '0px' },
        }}
      >
        {/* Portfolio Title Section */}
        <CommonTop
          sx={{
            display: {
              xs: 'none',
              md: 'block',
            },
          }}
          avatar
          title={detail?.title ? detail?.title : ''}
          subtitle="Pools Of Real-World Assets"
        />
        <Box
          sx={{
            padding: '24px',
            maxWidth: '1680px',
          }}
        >
          {/* Portfolio Content Section */}
          {detail && <PoolExplain contractAddr={contractAddr} detail={detail} />}
          {/* Staked Detail Section */}
          {contractAddr && <ClaimList contractAddr={contractAddr} />}
          {/* 종료, 중지 관련 (원금 회수)  */}
          {detail &&
            [
              PoolState.POOLSTATE_FUNDRAISING_STOPPED,
              PoolState.POOLSTATE_FUNDRAISING_FAILED,
              PoolState.POOLSTATE_OPERATING_CLOSED,
              PoolState.POOLSTATE_OPERATING_STOPPED,
            ].includes(detail.state) && <TriggerWithdrawAll />}
          {/* 대기 관련 */}
          {detail &&
            [
              PoolState.POOLSTATE_FUNDRAISING,
              PoolState.POOLSTATE_FUNDRAISING_LOCKED,
              PoolState.POOLSTATE_FUNDRAISING_STOPPED,
              PoolState.POOLSTATE_FUNDRAISING_FAILED,
            ].includes(detail.state) && <TriggerUnStakeList />}
          {/* 운영 관련 */}
          {detail &&
            [
              PoolState.POOLSTATE_OPERATING,
              PoolState.POOLSTATE_OPERATING_CLOSED,
              PoolState.POOLSTATE_OPERATING_STOPPED,
            ].includes(detail.state) && <TriggerRewardList />}
        </Box>
      </Box>
    </>
  );
}
